<template>
  <div class="workout-summary">
    <div class="row justify-content-between" style="width: 100%;">
      <div class="col" style="max-width: 30%;" >
        <ActivityDetails v-if="workoutStats && chartLabels && chartData" 
          :data="workoutInfo" 
          :stats-avilable="workoutStatsAvailable" />
      </div>
      <div class="col" style="padding-left:0;" 
        :style="workoutStatsAvailable ? 'width: 35% !important;' : 'width: 70% !important;padding-right:0;'">
        <ActivityStrain v-if="workoutStats && chartLabels && chartData" :activity-data="workoutInfo" 
        :stats-avilable="workoutStatsAvailable" :workout-stats="workoutStats" />
      </div>
      <div v-if="workoutStatsAvailable" class="col" style="padding-left:0;padding-right:0;width: 35%">
        <WorkoutStatistics v-if="workoutInfo" :data="workoutInfo" />
      </div>
    </div>
    <div class="row justify-content-between" style="width: 100%;padding-top:1rem;">
      <div v-if="zoneContributionDetails" class="col"  style="width: 30%;max-width: 30%;">
        <HeartRateZones :zone-data="zoneContributionDetails"></HeartRateZones>
      </div>
      <div v-if="workoutStats && chartLabels && chartData" class="col workout-intensity" style="width: 70%;">
        <WorkoutIntensity :workout-stats="workoutStats" :chart-labels="chartLabels" :chart-data="chartData" 
                          :hr-zone-vals="hrZoneVals" />
      </div>
    </div>
  </div>
  <div>
    <button v-if="false" class="done-button">DONE</button>
  </div>
</template>

<script>
import ActivityDetails from './ActivityDetails.vue';
import WorkoutStatistics from './WorkoutStatistics.vue';
import WorkoutIntensity from './WorkoutIntensity.vue';
import ActivityStrain from './ActivityStrain.vue';
import HeartRateZones from './HeartRateZones.vue';
import DateUtils from '@/helpers/dateUtils';
import Utils from "@/helpers/utils";

export default {
  name: 'WorkoutSummary',
  components: {
    ActivityDetails,
    WorkoutStatistics,
    WorkoutIntensity,
    ActivityStrain,
    HeartRateZones,
  },
  props: {
    workoutData: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    }
  },
  mounted() {
    this.workoutInfo = this.workoutData;
    this.getUserWorkoutDetails();
  },
  data() {
    return {
      workoutInfo: null,
      chartLabels: [],
      chartData: [],
      workoutStats: null,
      zoneContributionDetails: null,
      workoutStatsAvailable: false,
      hrZoneVals : null
    }
  },
  watch: {
    workoutData() {
      this.workoutInfo = this.workoutData;
    }
  },
  methods: {
    getUserWorkoutDetails() {
      let params = { udid: this.workoutInfo.udid, workout_record_id: this.workoutInfo.workout_record_id };
      this.$store.dispatch("data/userWorkoutDetails", params).
        then((data) => {
          this.workoutDetails = data;
          this.transformToChartData();
        }
        );
    },
    transformToChartData() {
      this.calculateActivityStats();
      let startingHr = 0, latestHr = 0, minHRate = 0;
      let heartRateTime = '';
      this.prepareHrZonePercentageInfo();
      // fit bars to 60
      if (this.workoutDetails.length > 80) {
        let splitRecordCount = Math.round(this.workoutDetails.length / 40);
        let start = 0, end = splitRecordCount;
        for (let i = 0; i < 40; i++) {
          let chunkData = this.workoutDetails.slice(start, end);
          if (chunkData.length > 0) {
            let info = this.getHeartRateFromSplitArray(chunkData);
            this.chartLabels.push(info.heartRateTime);
            this.chartData.push({ x: info.heartRateTime, y: [info.minHr, info.maxHr] });
            start = end;
            end = end + splitRecordCount;
          }
        }
      } else {
        for (let i = 0; i < this.workoutDetails.length; i++) {
          let workoutInfo = this.workoutDetails[i];
          heartRateTime = DateUtils.formatTimestampToTime(workoutInfo.workout_detail_timestamp);
          startingHr = latestHr;
          latestHr = workoutInfo.heart_rate;
          if (minHRate == 0) {
            minHRate = latestHr;
          } else if (latestHr < minHRate) {
            minHRate = latestHr;
          }

          if (startingHr != 0) {
            this.chartLabels.push(heartRateTime);
            this.chartData.push({ x: heartRateTime, y: [startingHr, latestHr] });
          }
        }
      }
      this.checkForWorkoutStats();
    },
    prepareHrZonePercentageInfo() {
      let zoneArray = [0, 0, 0, 0, 0, 0];
      this.hrZoneVals =  this.getHrZoneRangeHeartRates(this.user.age);
      for (let i = 0; i < this.workoutDetails.length; i++) {
        if (this.workoutDetails[i].heart_rate < this.hrZoneVals.restZoneHr) {
          zoneArray[5] = zoneArray[5] + 1;
        } else if (this.workoutDetails[i].heart_rate >= this.hrZoneVals.restZoneHr &&
          this.workoutDetails[i].heart_rate < this.hrZoneVals.warmUpZoneHr) {
          zoneArray[4] = zoneArray[4] + 1;
        } else if (this.workoutDetails[i].heart_rate >= this.hrZoneVals.warmUpZoneHr &&
          this.workoutDetails[i].heart_rate < this.hrZoneVals.fatBurningZoneHr) {
          zoneArray[3] = zoneArray[3] + 1;
        } else if (this.workoutDetails[i].heart_rate >= this.hrZoneVals.fatBurningZoneHr &&
          this.workoutDetails[i].heart_rate < this.hrZoneVals.aerobicZoneHr) {
          zoneArray[2] = zoneArray[2] + 1;
        } else if (this.workoutDetails[i].heart_rate >= this.hrZoneVals.aerobicZoneHr &&
          this.workoutDetails[i].heart_rate < this.hrZoneVals.anAerobicZoneHr) {
          zoneArray[1] = zoneArray[1] + 1;
        } else if (this.workoutDetails[i].heart_rate >= this.hrZoneVals.anAerobicZoneHr) {
          zoneArray[0] = zoneArray[0] + 1;
        }
      }

      let total = zoneArray.reduce((a, b) => a + b, 0);
      this.zoneContributionDetails = [
        { label: "Extreme", percentage: 0, time: 0, color: "#D20000", bgColor:"#D200001A", class: "extreme", gradient:"#D20000" },
        { label: "Anaerobic", percentage: 0, time: 0, color: "#E57E12", bgColor:"#E57E121A", class: "anaerobic", gradient:"#E57E12" },
        { label: "Aerobic", percentage: 0, time: 0, color: "#FFE14B", bgColor:"#FFE14B26", class: "aerobic", gradient:"#FFE14B" },
        { label: "Fat-burning", percentage: 0, time: 0, color: "#96F189", bgColor:"#96F18926", class: "fat-burning", gradient:"#96F189"},
        { label: "Warm up", percentage: 0, time: 0, color: "#74B8E6", bgColor:"#74B8E626", class: "warm-up", gradient:"#74B8E6"},
        { label: "Resting", percentage: 0, time: 0, color: "#8A74E6", bgColor:"#8A74E626", class: "rest", gradient:"#8A74E6" },
      ];
      for (let i = 0; i < zoneArray.length; i++) {
        this.zoneContributionDetails[i].percentage = Math.round(zoneArray[i] / total * 100);
        let zoneTime = Utils.formatDurationInHrsAndMins(zoneArray[i] * 5);
        this.zoneContributionDetails[i].time = zoneTime;
      }
    },
    getHrZoneRangeHeartRates(age) {
      let MAX_HR = 220 - age;
      let REST_ZONE = 0.5, WARM_UP = 0.6, FAT_BURNING = 0.7, AEROBIC = 0.8, ANAEROBIC = 0.9;

      let restZoneHr = parseInt(REST_ZONE * MAX_HR);
      let warmUpZoneHr = parseInt(WARM_UP * MAX_HR);
      let fatBurningZoneHr = parseInt(FAT_BURNING * MAX_HR);
      let aerobicZoneHr = parseInt(AEROBIC * MAX_HR);
      let anAerobicZoneHr = parseInt(ANAEROBIC * MAX_HR);
      
      return { restZoneHr, warmUpZoneHr, fatBurningZoneHr, aerobicZoneHr, anAerobicZoneHr };
    },
    getHeartRateFromSplitArray(chunkData) {
      let heartRateTime = DateUtils.formatTimestampTo24HrsTime(chunkData[0].workout_detail_timestamp);
      let minHr = Math.min(...chunkData.map(item => item.heart_rate));
      let maxHr = Math.max(...chunkData.map(item => item.heart_rate));

      return { heartRateTime, minHr, maxHr };
    },
    calculateActivityStats() {
      let minHR = 0, maxHR = 0;
      for (let workoutInfo of this.workoutDetails) {
        if (minHR == 0) {
          minHR = workoutInfo.heart_rate;
        } else {
          minHR = workoutInfo.heart_rate < minHR ? workoutInfo.heart_rate : minHR;
        }

        maxHR = workoutInfo.heart_rate > maxHR ? workoutInfo.heart_rate : maxHR;
      }

      let avgHeartRate = Math.round(this.workoutDetails.reduce((r, c) => r + c.heart_rate, 0) / this.workoutDetails.length);
      this.workoutStats = {
        minHeartRate: minHR,
        maxHeartRate: maxHR,
        avgHeartRate: avgHeartRate,
      };
    },
    checkForWorkoutStats() {
      if (this.workoutInfo.workout_record_step > 0 || this.workoutInfo.avg_cadence > 0
        || this.workoutInfo.workout_max_met > 0 || this.workoutInfo.avg_pace > 0
        || this.workoutInfo.fastest_pace
      ) {
        this.workoutStatsAvailable = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/* Add your CSS styles here to match the design of the image */
.workout-intensity {
  background-color: #1C1D1F;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>